import React from 'react';

export const RHPSubtitle: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <p className="right-hand-panel-subtitle font-pt-sans text-black text-[16px] m-0 font-[700]">
      {children}
    </p>
  )
}